import { styled } from '@mui/material/styles';

import { Theme, px, rem } from '../../../theme';

const heightMobile = 110;
const widthMobile = 110;

const heightDesktop = 220;
const widthDesktop = 300;

export const desktopImageSizes = [heightDesktop, widthDesktop];
export const mobileImageSizes = [heightMobile, widthMobile];

export const StyledContainer = styled('div')`
    width: fit-content;
    background-color: ${({ theme }: { theme: Theme }) =>
        theme.palette.common.white};
`;

export const StyledImageContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(px(widthMobile), widthMobile / 4)};
        height: ${theme.tggSpacing(px(heightMobile), heightMobile / 4)};

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(px(widthDesktop), widthDesktop / 4)};
            height: ${theme.tggSpacing(px(heightDesktop), heightDesktop / 4)};
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: ${theme.tggSpacing(rem(0.8), 2)};
        }
	`}
`;

export const StyledHeading = styled('div')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_19_bold_desktop_21};
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(11), 27.5)};
        margin: ${theme.tggSpacing([rem(1.5), 0, rem(0.5)], [3.75, 0, 1.25])};
        color: ${theme.palette.primary.main};
        text-transform: lowercase;

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(30), 75)};
        }
    `}
`;

export const StyledStoryContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: 100vw;
        height: 100vh;
        padding: ${theme.tggSpacing(rem(2), 5)};
        background-color: ${theme.palette.grey[100]};
    `}
`;
